(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cx-temoignages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function lazyVideos(root) {
      var vids = root.querySelectorAll('.cx-tv__video[data-src]');
      function load(v) { v.src = v.getAttribute('data-src'); v.removeAttribute('data-src'); v.preload = 'metadata'; }
      if (!('IntersectionObserver' in window)) { return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); load(en.target); } });
      }, { rootMargin: '300px 0px' });
      var seen = root.querySelector('.cx-tv__viewport');
      if (!seen) return;
      var top = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { top.disconnect(); vids.forEach(function (v) { io.observe(v); }); }
      }, { rootMargin: '600px 0px' });
      top.observe(seen);
    }
    function init(root) {
      var modal = root.querySelector('.cx-tv__modal');
      if (!modal || modal.dataset.ready) return;
      modal.dataset.ready = '1';
      lazyVideos(root);
      var player = modal.querySelector('.cx-tv__player');
      function stop() { try { player.pause(); } catch (e) {} }
      function close() { stop(); player.removeAttribute('src'); player.load(); if (modal.open) modal.close(); }
      function start() {
        var p = player.play();
        if (p && p.catch) { p.catch(function () { player.muted = true; var q = player.play(); if (q && q.catch) q.catch(function () {}); }); }
      }
      root.addEventListener('click', function (e) {
        var card = e.target.closest('.cx-tv__card');
        if (!card) return;
        player.muted = false;
        player.src = card.getAttribute('data-cx-tv-src');
        player.load();
        if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); } else { modal.setAttribute('open', ''); }
        start();
        player.addEventListener('canplay', function onReady() { player.removeEventListener('canplay', onReady); if (player.paused) start(); });
      });
      modal.querySelector('.cx-tv__close').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.addEventListener('cancel', stop);
      modal.addEventListener('close', stop);
    }
    function boot() { document.querySelectorAll('.cx-tv').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
